import { render, staticRenderFns } from "./OfficialPost.vue?vue&type=template&id=c6a400b4&lang=html"
import script from "./OfficialPost.vue?vue&type=script&lang=js"
export * from "./OfficialPost.vue?vue&type=script&lang=js"
import style0 from "./OfficialPost.vue?vue&type=style&index=0&id=c6a400b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports